import { PaginationState } from '@tanstack/react-table'

export const buildPaginationParams = (pageSize: number, pageIndex: number) => ({ page: pageIndex + 1, limit: pageSize })

export const buildTablePaginationParams = (pagination: PaginationState) => ({
  page: pagination.pageIndex + 1,
  limit: pagination.pageSize,
})
